"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSmartPlasticsPartApp = exports.SmartPlasticsPartAppSchema = void 0;
const zod_1 = require("zod");
const echain_shared_i18n_1 = require("@igus/echain-shared-i18n");
const SmartPlasticsPartSchema_1 = require("../../generated/zod/modelSchema/SmartPlasticsPartSchema");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const ArticleRef_1 = require("../ArticleRef");
const ArticleType_1 = require("../ArticleType");
const zod_2 = require("../../generated/zod");
exports.SmartPlasticsPartAppSchema = SmartPlasticsPartSchema_1.SmartPlasticsPartSchema.omit({
    // remove new property names
    akeneoSku: true,
    akeneoUuid: true,
    artNr: true,
    articleSpecs: true,
    articleType: true,
    dataSource: true,
    discontinuedModel: true,
    description: true,
    echainId: true,
    weightUnit: true,
    ecfAllowed: true,
    eicAllowed: true,
    eiqAllowed: true,
    ekeAllowed: true,
}).extend({
    // add old property names
    AkeneoSku: zod_1.z.string(),
    AkeneoUuid: zod_1.z.string().nullish(),
    ArtNr: zod_1.z.custom(echain_shared_i18n_1.isLocalizedText, { message: 'invalid LocalizedText' }),
    ArticleSpecs: zod_2.ArticleSpecSchema.array(),
    ArticleType: zod_1.z.custom((a) => a === ArticleType_1.ArticleType.zubehoer, { message: 'invalid ArticleType' }),
    DataSource: zod_2.DataSourceSchema,
    DiscontinuedModel: zod_1.z.boolean({
        required_error: 'DiscontinuedModel is required',
        invalid_type_error: 'DiscontinuedModel must be a boolean',
    }),
    EchainId: zod_1.z.string(),
    Bezeichnung: zod_1.z.custom(echain_shared_i18n_1.isLocalizedText, { message: 'invalid LocalizedText' }),
    FreigabeECF: zod_1.z.boolean(),
    FreigabeEIC: zod_1.z.boolean(),
    FreigabeEIQ: zod_1.z.boolean(),
    FreigabeEKE: zod_1.z.boolean(),
    interiorDrawingProperties: zod_1.z
        .object({
        iaBodenH_mm: zod_1.z.number().optional(),
        iaHKBOT_mm: zod_1.z.number().optional(),
        iaHKB_mm: zod_1.z.number().optional(),
        iaHKDist_mm: zod_1.z.number().optional(),
        iaHKH_mm: zod_1.z.number().optional(),
        iaHKHeight_mm: zod_1.z.number().optional(),
        iaHKOLB_mm: zod_1.z.number().optional(),
        iaHKOLOB_mm: zod_1.z.number().optional(),
        iaHKOLOH_mm: zod_1.z.number().optional(),
        iaHKOLUB_mm: zod_1.z.number().optional(),
        iaHKOLUH_Rounded: zod_1.z.boolean().optional(),
        iaHKOLUH_mm: zod_1.z.number().optional(),
        iaHKORB_mm: zod_1.z.number().optional(),
        iaHKOROB_mm: zod_1.z.number().optional(),
        iaHKORUB_mm: zod_1.z.number().optional(),
        iaHKRep: zod_1.z.number().optional(),
        iaHKULB_mm: zod_1.z.number().optional(),
        iaHKULOB_mm: zod_1.z.number().optional(),
        iaHKULOH_Rounded: zod_1.z.boolean().optional(),
        iaHKULOH_mm: zod_1.z.number().optional(),
        iaHKULUB_mm: zod_1.z.number().optional(),
        iaHKULUH_mm: zod_1.z.number().optional(),
        iaHKURB_mm: zod_1.z.number().optional(),
        iaHKUROB_mm: zod_1.z.number().optional(),
        iaHKURUB_mm: zod_1.z.number().optional(),
        iaKisteHO_mm: zod_1.z.number().optional(),
        iaKisteHU_mm: zod_1.z.number().optional(),
        iaUebermass_mm: zod_1.z.number().optional(),
        iawmm_mm: zod_1.z.number().optional(),
    })
        .nullish()
        .transform((x) => (x && Object.keys(x).length ? x : undefined))
        .optional(),
    partsReferences: zod_1.z.custom(ArticleRef_1.isArticleRef, { message: 'invalid ArticleRef' }).array(),
    weight: zod_1.z.custom(echain_shared_quantities_1.isWeightJson, { message: 'invalid WeightPerLengthJson' }),
});
const isSmartPlasticsPartApp = (whatever) => {
    var _a;
    return (_a = exports.SmartPlasticsPartAppSchema.safeParse(whatever)) === null || _a === void 0 ? void 0 : _a.success;
};
exports.isSmartPlasticsPartApp = isSmartPlasticsPartApp;
//# sourceMappingURL=SmartPlasticsPartApp.js.map